"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ApplePay = _interopRequireDefault(require("./ApplePay"));
var _GooglePay = _interopRequireDefault(require("./GooglePay"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var WalletPayment = function WalletPayment(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isApplePayActive = _useState2[0],
    setIsApplePayActive = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isGooglePayActive = _useState4[0],
    setIsGooglePayActive = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    key = _useState6[0],
    setKey = _useState6[1];
  (0, _react.useEffect)(function () {
    return setKey(key + 1);
  }, [props.paidAmount]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-l-auto-grid"
  }, /*#__PURE__*/_react["default"].createElement(_ApplePay["default"], (0, _extends2["default"])({}, props, {
    setIsApplePayActive: setIsApplePayActive,
    isApplePayActive: isApplePayActive
  })), /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
    key: key
  }, /*#__PURE__*/_react["default"].createElement(_GooglePay["default"], (0, _extends2["default"])({}, props, {
    setIsGooglePayActive: setIsGooglePayActive
  })))), (isApplePayActive || isGooglePayActive) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center margin-y-xl text-xs line-split"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Or pay with card")));
};
WalletPayment.propTypes = {
  paidAmount: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = WalletPayment;